import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/** Legacy /login route — redirects to the new landing page login flow. */
const Login = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        navigate('/', {
            replace: true,
            state: location.state || {},
        });
    }, [navigate, location.state]);

    return null;
};

export default Login;
